import { render, staticRenderFns } from "./SurveyIndicator.vue?vue&type=template&id=2ed37f12&"
import script from "./SurveyIndicator.vue?vue&type=script&lang=js&"
export * from "./SurveyIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports